import axios from 'axios';

// Resolve the current user's id. Primary source is the 'userId' key in
// localStorage; when it's absent (login flows that only store the token),
// fall back to decoding our OWN JWT's payload — the id lives there anyway,
// it's what the server reads. This is plain base64 decoding of a token we
// already hold, not verification.
function getUserId() {
  const savedId = localStorage.getItem('userId');
  if (savedId) return savedId;

  const token = localStorage.getItem('userToken');
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const id = payload.id ?? payload.userId ?? payload.sub ?? null;
      if (id !== null && id !== undefined) {
        // Cache it so the fallback only runs once per session.
        localStorage.setItem('userId', String(id));
        return String(id);
      }
    } catch (e) {
      console.error('Could not decode userId from token:', e);
    }
  }

  console.error('No user ID available (neither localStorage.userId nor token payload).');
  return null;
}

const state = {
  settings: {} 
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },
};

const actions = {
  async fetchSettings({ commit }) {
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
      return null; // Handle no token case
    }

    const savedId = getUserId();
    if (!savedId) {
      return null; 
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.get(`${baseUrl}/users/${savedId}/settings`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('API Response:', response.data);
  
      if (response.data) {
        
        commit('setSettings', response.data); 
        return response.data;
      } else {
        console.error('No settings found in API response.');
        return null; 
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  async updateSettings({ commit }, settings) { 
    const userToken = localStorage.getItem('userToken');
    const savedId = getUserId();

    if (!userToken || !savedId) {
      throw new Error('Cannot save settings: missing token or user id');
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.put(`${baseUrl}/users/${savedId}/settings`, settings, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('Update Response:', response.data); // Log response
      return response.data; // Return update confirmation if needed
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error; // Propagate error
    }
  },
};

// NEW: Added getters for consistency
const getters = {
  getSettings: (state) => state.settings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};